export class Grupo {
    id: string;
    nome: string;
    descricao: string;
    status: string;
}
